// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__19gIz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3x_rL"};